/* Container.tsx
   Version: 1.0.0
   Date: 2020-11-28
*/

// eslint-disable-next-line
import React from 'react';
import PropTypes from 'prop-types';

export interface ContainerProps {
    children?: React.ReactNode,
    className: string;
}

const Container: React.FC<ContainerProps> = (props): JSX.Element => {

    Container.propTypes = {
        children: PropTypes.node,
        className: PropTypes.string.isRequired
    }
    
    
    return(
        <div className={props.className}>{props.children}</div>
    );

}

export default Container;
